import {Component, Input, OnInit} from '@angular/core';
import {LMBuilderModel} from "@components/builder/services/lm-builder-model.service";

@Component({
  selector:    'lm-builder-export',
  standalone: false,
  templateUrl: './lm-builder-export.component.html',
  styleUrl: './lm-builder-export.component.scss',
})

export class LMBuilderExportComponent implements OnInit {
  @Input() spec!: LMListPSpec;

  pdfPaperSizeIDSAttributes = [ { name: 'data-automation-id', value: 'lm-builder-pdf-paper-size' } ];
  pdfPaperSizeUomIDSAttributes = [ { name: 'data-automation-id', value: 'lm-builder-pdf-paper-uom' } ];
  exportRetentionDurationIDSAttributes = [ { name: 'data-automation-id', value: 'lm-builder-export-retention-duration' } ];
  exportRetentionDurationCustomIDSAttributes = [ { name: 'data-automation-id', value: 'lm-builder-export-retention-duration-custom' } ];
  exportRetentionDurationCustomSpinBoxDataOptions = JSON.stringify({ min: 1, max: 9999, step: 1, attributes: this.exportRetentionDurationCustomIDSAttributes });
  pdfFontOffsetOptionIDSAttributes  = [ { name: 'data-automation-id', value: 'lm-builder-pdf-font-offset-option-dropdown' } ];
  customPdfFontOffsetIDSAttributes = [ { name: 'data-automation-id', value: 'lm-builder-custom-pdf-font-offset' } ];
  customPdfFontOffsetSpinBoxAttributes = JSON.stringify({ min: -5, max: 20, attributes: this.customPdfFontOffsetIDSAttributes });

  pdfOrientation: LMBuilderPDFOrientation = 'landscape';
  exportRetentionDuration: LMBuilderExportRetentionDuration = 'default';
  pdfOffsetOption: LMBuilderPdfOffsetOption = 'default';
  pdfOffset = 0;

  constructor(
      private lmBuilderModel: LMBuilderModel,
  ) {
  // no-op
  }

  ngOnInit(): void {
    this.initializePdfOrientation();
    this.initializeExportRetentionDuration();
    this.initializePdfOffset();
  }

  private initializePdfOffset() {
    if (this.spec.userFolder) {
      if (this.lmBuilderModel.mode === 'createReport') {
        this.spec.userFolder.exportOverride.pdfOffset = this.spec.pdfOffset;
      }
      this.pdfOffset = this.spec.userFolder.exportOverride.pdfOffset;
    } else {
      this.pdfOffset = this.spec.pdfOffset;
    }

    if (!this.pdfOffsetOption) {
      this.pdfOffsetOption = 'default';
      this.pdfOffset = 0;
    } else if (this.pdfOffset === 0) {
      this.pdfOffsetOption = 'default';
    } else if (this.pdfOffset  === -2) {
      this.pdfOffsetOption = 'small';
    } else if (this.pdfOffset  === -3) {
      this.pdfOffsetOption = 'smaller';
    } else if (this.pdfOffset  === -5) {
      this.pdfOffsetOption = 'smallest';
    } else {
      this.pdfOffsetOption ='custom';
    }

    // @ts-ignore
    Soho.Validation.rules['validatePDFCustomPaperSize'] = this.lmBuilderModel.validatePDFCustomPaperSize();
  }

  updatePdfOffsetOption() {
    if (this.pdfOffsetOption === 'default') {
      this.pdfOffset = 0;
    } else if (this.pdfOffsetOption === 'small' ) {
      this.pdfOffset = -2;
    } else if (this.pdfOffsetOption === 'smaller' ) {
      this.pdfOffset = -3;
    } else if (this.pdfOffsetOption=== 'smallest') {
      this.pdfOffset = -5;
    } else if (this.pdfOffsetOption !== 'custom') {
      this.pdfOffset = 0;
    }
    if (this.spec.userFolder) {
      this.spec.userFolder.exportOverride.pdfOffset = this.pdfOffset;
    } else {
      this.spec.pdfOffset = this.pdfOffset;
    }
  }

  updateCustomPdfOffset() {
    if (this.spec.userFolder) {
      this.spec.userFolder.exportOverride.pdfOffset = this.pdfOffset;
    } else {
      this.spec.pdfOffset = this.pdfOffset;
    }
  }

  private initializeExportRetentionDuration() {
    if (this.spec.userFolder) {
      const retentionDuration = this.spec.userFolder.exportOverride.retentionDuration;
      if (retentionDuration != undefined) {
        if (retentionDuration === 0 || retentionDuration === 180) {
          this.exportRetentionDuration = 'default';
          this.spec.userFolder.exportOverride.retentionDuration = 0;
        } else if (retentionDuration === 7) {
          this.exportRetentionDuration = 'one-week';
        } else if (retentionDuration === 30) {
          this.exportRetentionDuration = 'one-month';
        } else if (retentionDuration === 365) {
          this.exportRetentionDuration= 'one-year';
        } else if (retentionDuration === 1825) {
          this.exportRetentionDuration = 'five-years';
        } else {
          this.exportRetentionDuration ='custom';
        }
      } else {
        this.exportRetentionDuration = 'default';
      }
    }
  }

  updateExportRetentionDuration() {
    if (this.spec.userFolder) {
      if (this.exportRetentionDuration === 'default') {
        this.spec.userFolder.exportOverride.retentionDuration = 0;
      } else if (this.exportRetentionDuration=== 'one-week' ) {
        this.spec.userFolder.exportOverride.retentionDuration = 7;
      } else if (this.exportRetentionDuration === 'one-month' ) {
        this.spec.userFolder.exportOverride.retentionDuration = 30;
      } else if (this.exportRetentionDuration === 'one-year') {
        this.spec.userFolder.exportOverride.retentionDuration = 365;
      } else if (this.exportRetentionDuration === 'five-years') {
        this.spec.userFolder.exportOverride.retentionDuration = 1825;
      } else if (this.exportRetentionDuration !== 'custom') {
        this.spec.userFolder.exportOverride.retentionDuration = 0;
      }
    }
  }

  private initializePdfOrientation() {
    if (this.spec.userFolder) {
      if (this.lmBuilderModel.mode === 'createReport') {
        this.spec.userFolder.exportOverride.pdfOrientation = this.spec.pdfOrientation ? this.spec.pdfOrientation : 'landscape';
      }
      this.pdfOrientation = this.spec.userFolder.exportOverride.pdfOrientation;
    } else {
      this.pdfOrientation = this.spec.pdfOrientation;
    }
  }

  updatePdfOrientation() {
    this.lmBuilderModel.updatePdfOrientation(this.pdfOrientation);
  }

  updatePdPaperSize() {
    // this.lmBuilderModel.updatePdfOrientation(this.pdfOrientation);
  }
}
